import { defineComponent } from 'vue-demi'
import { connect, h, mapProps, mapReadPretty, useField } from '@formily/vue'
import { Switch as RichSwitch } from '@didi/rich-ui'
import { EventBus } from '../FormItemWithSwitch/utils'
import './style.scss'

const TransformElSwitch = defineComponent({
  name: 'FSwitch',
  props: {
    value: {},
    disabled: {}
  },
  setup (props, { attrs, slots, listeners, emit }) {
    return () => {
      return h(
        RichSwitch,
        {
          attrs: {
            ...attrs
          },
          props: {
            ...props
          },
          on: {
            ...listeners,
            input (value) {
              emit('change', value)
              EventBus.$emit('change', value)
            }
          }
        },
        {
          default: () => {
            return props.value ? 'Yes' : 'No'
          }
        }
      )
    }
  }
})

const ReadPrettySwitch = defineComponent({
  name: 'ReadPrettySwitch',
  setup (props, {attrs}) {
    const fieldRef = useField()
    const field = fieldRef.value
    return () => {
      return h(
        RichSwitch,
        {
          props: {...props},
          attrs: {...attrs}
        }, {
          default: () => {
            return field.value ? 'Yes' : 'No'
          }
        }
      )
    }
  }
})

const Switch = connect(
  TransformElSwitch,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(ReadPrettySwitch, {disabled: true})
)

export default Switch
